(function ($) {
  "use strict";

  const apps_per_hire = 85;
  const apps_interviewed = 0.03;
  const interview_per_person = 2;
  const interview_hired = 0.48;
  const avg_apps_scheduled = 0.08;
  const premium_apps_scheduled = 0.64;
  const schedule_time = 15;
  const premium_savings = 0.91;

  function single_precision(value) {
    return Math.round(value * 10) / 10
  }

  function updateValue(value) {
    const avg_time_in_minutes = Math.floor(
      value *
      apps_per_hire *
      apps_interviewed *
      interview_per_person *
      schedule_time
    );
    const premium_time_in_minutes = Math.floor(
      avg_time_in_minutes - (avg_time_in_minutes * premium_savings)
    );
    const interviews = value / interview_hired;
    const avg_invites = Math.round(interviews / avg_apps_scheduled);
    const premium_invites = Math.round(interviews / premium_apps_scheduled);

    $(".cp-value-calc__hires_value").text(value);
    if (avg_time_in_minutes < 60) {
      $(".cp-value-calc__average_time_value").text(avg_time_in_minutes);
      $(".cp-value-calc__average_time_label").text('minutes');
    } else {
      $(".cp-value-calc__average_time_value").text(single_precision(avg_time_in_minutes / 60));
      $(".cp-value-calc__average_time_label").text('hours');
    }
    $(".cp-value-calc__average_interviews_value").text(avg_invites);
    if (premium_time_in_minutes < 60) {
      $(".cp-value-calc__premium_time_value").text(premium_time_in_minutes);
      $(".cp-value-calc__premium_time_label").text('minutes');
    } else {
      $(".cp-value-calc__premium_time_value").text(single_precision(premium_time_in_minutes / 60));
      $(".cp-value-calc__premium_time_label").text('hours');
    }
    $(".cp-value-calc__premium_interviews_value").text(premium_invites);
  }

  $(function () {
    const onSliderInput = function () {
      const sliderEl = document.querySelector(".cp-value-calc__slider");
      const sliderValue = sliderEl.value;
      const progress = (sliderValue / sliderEl.max) * 100;
      sliderEl.style.background = `linear-gradient(to right, #00bed6 ${progress}%, #9b9b9b ${sliderValue}%)`;
      if (sliderValue > 1) {
        updateValue(sliderValue);
      } else {
        updateValue(1);
      }
    };
    $(".cp-value-calc__slider").on('input', onSliderInput);
    onSliderInput();
    updateValue(1);
  });
})(jQuery);
